import {firstValueFrom, take} from 'rxjs';
import {signMessage as walletSignMessage, connect} from '@wagmi/core';
import {InjectedConnector} from '@wagmi/core/connectors/injected';
import {bridge} from '@/helper/bridge';
import {chains} from './shared';
import {connector$} from './connectors';
import {CustomObservableError} from '../utils';
import {defineWalletConnectBridge, shouldUseAppWalletConnect$} from './bridge';

const APP_SIGN_METHOD_NAME = 'appSign';
let signSuccessCallback;
let signErrorCallback;
export async function signMessage(message: string) {
  const data = await new Promise((resolve, reject) => {
    shouldUseAppWalletConnect$.pipe(take(1)).subscribe((shouldUseAppWalletConnect) => {
      if (shouldUseAppWalletConnect) {
        signSuccessCallback = resolve;
        signErrorCallback = reject;
        bridge.postJSON({type: 'walletSign', message, callback: APP_SIGN_METHOD_NAME});
        return;
      }
      signMessageByWeb(message).then(resolve).catch(reject);
    });
  });
  return data;
}

defineWalletConnectBridge(() => {
  (window as any)[APP_SIGN_METHOD_NAME] = function (result) {
    try {
      const {code, msg, data} = JSON.parse(result);
      if (code == 0) {
        const {signedMessage} = data;
        signSuccessCallback(signedMessage);
        return;
      }
      signErrorCallback(new Error(msg));
    } catch (error) {
      signErrorCallback(error);
    }
  };
});

export async function signMessageByWeb(message: string) {
  const signData = await safeSignMessage(message);
  if (signData) {
    return signData;
  }
  const {connector} = await firstValueFrom(connector$);
  if (!connector?.isConnected) {
    await connect({
      chainId: chains[0].id,
      connector: new InjectedConnector(),
    });
  }
  return safeSignMessage(message);
}

async function safeSignMessage(message: string) {
  const connector = await firstValueFrom(connector$);
  if (connector.connector.isConnected) {
    try {
      const response = await walletSignMessage({message});
      return response;
    } catch (error) {
      if ([-32603].includes(Number(error?.code || 0))) {
        throw new CustomObservableError(error?.message);
      }
      throw error;
    }
  }
}
